export default function DamData(currentMode, currentArea, datas, dataTime) {
  let damData = [];

  // filter data by area (province or basin)
  if (currentMode === 'province' && currentArea.code !== '0') {
    damData = datas.filter((d) => d.geocode.province_code === currentArea.code);
  } else if (currentMode === 'basin' && currentArea.code !== '0') {
    damData = datas.filter((d) => d.basin.basin_code === parseInt(currentArea.code, 10));
  } else {
    damData = datas;
  }

  // yellow
  const damYellow = damData.filter((d) => d.dam_uses_water_percent <= 30);

  // red
  const damRed = damData.filter((d) => d.dam_storage_percent > 80);

  // count
  const damRedCount = damRed.length;

  const damList = {
    time: dataTime,
    count: damRedCount,
    yellow: damYellow,
    red: damRed,
  };

  return ({
    damList,
  });
}
